import { slugify } from '@/utils/slug';

import { type BrandName, featuredBrandNames } from './brandNames';
import { brandOrigins } from './brandOrigins';
import { type CountryKey } from './countries';

/**
 * A make, resolved: its name, the slug its page lives at, and the country it
 * comes from.
 *
 * `country` is on the Brand rather than looked up at each call site because
 * three separate surfaces now filter by it — the header's brand menu, the
 * drawer's and Shop by Make — and a lookup repeated three times is a lookup
 * that will eventually be done two different ways.
 */
export type Brand = { name: BrandName; slug: string; country: CountryKey };

export const featuredBrands: readonly Brand[] = featuredBrandNames.map((name) => ({
  name,
  slug: slugify(name),
  country: brandOrigins[name],
}));
